import React from 'react';

/**
 * In-page step header (checkout is one route; steps switch internally, not via
 * the router). Sticky so the close button stays reachable on long steps
 * (e.g. the payment/bill-breakdown step) without scrolling back up — pinned
 * just below the app's own sticky top bar, not overlapping it.
 */
export default function StepHeader({ title, sub, onClose }) {
  return (
    <div className="sticky top-14 md:top-[76px] z-20 -mx-4 md:-mx-6 px-4 md:px-6 py-3.5 mb-4 flex items-start justify-between bg-paper/95 backdrop-blur border-b border-black/5 shadow-soft">
      <div>
        <div className="font-black text-lg text-brand-dark">{title}</div>
        {sub ? <div className="text-xs text-ink-faint mt-0.5">{sub}</div> : null}
      </div>
      {onClose ? (
        <button
          type="button"
          onClick={onClose}
          aria-label="Close checkout"
          className="shrink-0 h-8 w-8 rounded-full bg-red-50 text-red-600 font-black text-sm flex items-center justify-center hover:bg-red-100"
        >
          ✕
        </button>
      ) : null}
    </div>
  );
}
